import 'Core/components/Dashboard/Dashboard.sass';
import {showModal} from 'Core/ducks/modal';
import React from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router';
import {ReducerState} from 'rootReducer';
import withUserClaims, {WithClaimsProps} from 'Shared/components/withUserClaims';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';

type PortalDashboardProps = {
  showModal: typeof showModal;
} & ReturnType<typeof mapStateToProps> &
  WithClaimsProps &
  RouteComponentProps;

export const PortalDashboard = (props: PortalDashboardProps) => {
  return <div className="dashboard"></div>;
};

const mapStateToProps = (state: ReducerState) => ({
  scopes: selectUserScopes(state),
});

export default withUserClaims(
  withRouter(
    connect(mapStateToProps, {
      showModal,
    })(PortalDashboard)
  )
);
